export { default as DecisionSlider } from "./DecisionSlider";
